<template>
	<div class="poreareaguide">
		<Loading msg="loading" v-if="!isload" />
		<div class="guide_inner" v-else>
      		<img @click="$parent.routerGo('/skincarekeypoints')"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
                <div class="guide_inner_up">
                <h1 class="guide_title">拯救毛孔粗大<span class="retest_ques" @click="$parent.routerGo('/poresurvey?redo=redo',(actParams = { query: $route.query, pageid: 495 }),{is_access:true,reportEvent_page_id:'495',reportEvent_page_name:'毛孔-重填问卷',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'毛孔'})">重填问卷</span></h1>
                <div class="yours_title">我的肤质特征</div>
                <div class="yours_result_container">
                    <p class="yours_result bordered">现状结果:<strong>{{guide_area_data.ph_skin_type}}肤质</strong></p>
                    <p class="yours_result bordered">基因结果:<strong>紧致能力{{guide_area_data.type17 == 'weak' ? '薄弱' : guide_area_data.type17 == 'excellent' ? '优质' : '中等'}}</strong></p>
                    <p class="yours_result yours_result_flex">问卷信息:<strong>{{guide_area_data.pore_level.pore ? guide_area_data.pore_level.pore : guide_area_data.pore_level.head_pore + '，' +guide_area_data.pore_level.face_pore}}</strong><img class="pore_level_icon" src="../assets/images/question_mark_icon.svg" alt="" @click="show_pore_level=true"></p>
                </div>
                    <div class="main_point_title">分区护理</div>
                    <div class="main_point_tip">根据您的特征，为您进行分区护理</div>
                    <div class="guide_area">
                        <span @click="$parent.routerGo('/poreguideareadetail?solution=t_solution')">T区护理</span>
                        <span @click="$parent.routerGo('/poreguideareadetail?solution=v_solution')">脸颊护理</span>
                    </div>
          
                </div>
              <!-- 毛孔3-6级描述弹窗 -->
              <transition name="fade">
                <div class="pore_level_toaster" v-if="show_pore_level">
                  <div class="pore_level_toaster_inner">
                    <div class="pore_level_toaster_inner_title"><span>毛孔3-6级的描述</span><img src="../assets/images/close_btn.svg" alt="" @click="show_pore_level=false"></div>
                    <div class="pore_level_toaster_inner_main">
                        <div class="survey_3 survey_item" v-if="survey_3">
                          <div class="survey_detail survey_detail_3">
                            <ul class="detail_options">
                              <li class="option_item">
                                <input type="radio" id="survey_3_a" value="A" disabled>
                                <label for="survey_3_a" :class="survey_3 == 'A' ? 'now' : 'hide'"><span>3级-清晰可见毛孔</span> <img src="../assets/images/pore_survey_1.png" alt=""></label>
                              
                              </li>
                              <li class="option_item">
                                <input type="radio" id="survey_3_b" value="B" disabled>
                                <label for="survey_3_b" :class="survey_3 == 'B' ? 'now' : 'hide'"><span>4级-明显可见毛孔，或内含小于毛孔大小的角栓</span><img src="../assets/images/pore_survey_2.png" alt=""></label>
                                
                              </li>
                              <li class="option_item">
                                <input type="radio" id="survey_3_c" value="C" disabled>
                                <label for="survey_3_c" :class="survey_3 == 'C' ? 'now' : 'hide'"><span>5级-非常明显可见毛孔，或内含与毛孔大小一致的角栓</span><img src="../assets/images/pore_survey_3.png" alt=""></label>
                                
                              </li>
                              <li class="option_item">
                                <input type="radio" id="survey_3_d" value="D" disabled>
                                <label for="survey_3_d" :class="survey_3 == 'D' ? 'now' : 'hide'"><span>6级-明显扩大毛孔，或内含突出毛孔的角栓，呈草莓样</span><img src="../assets/images/pore_survey_4.png" alt=""></label>
                                
                              </li>

                            </ul>
                          </div>
                      </div>
                      <!-- 第5，6题 -->
                      <div class="survey_5 survey_item" v-if="survey_5">
                        <div class="survey_detail survey_detail_5">
                          <ul class="detail_options detail_options_5">
                            <li class="option_item">
                              <input type="radio" id="survey_5_a" value="A" disabled>
                              <label for="survey_5_a" :class="survey_5 == 'A' ? 'now' : 'hide'"><span>3级-清晰可见毛孔</span><img src="../assets/images/pore_survey_1.png" alt=""></label>
                              
                            </li>
                            <li class="option_item">
                              <input type="radio" id="survey_5_b" value="B" disabled>
                              <label for="survey_5_b" :class="survey_5 == 'B' ? 'now' : 'hide'"><span>4级-明显可见毛孔，或内含小于毛孔大小的角栓</span> <img src="../assets/images/pore_survey_2.png" alt=""></label>
                            
                            </li>
                            <li class="option_item">
                              <input type="radio" id="survey_5_c" value="C" disabled>
                              <label for="survey_5_c" :class="survey_5 == 'C' ? 'now' : 'hide'"><span>5级-非常明显可见毛孔，或内含与毛孔大小一致的角栓</span> <img src="../assets/images/pore_survey_3.png" alt=""></label>
                            
                            </li>
                            <li class="option_item">
                              <input type="radio" id="survey_5_d" value="D" disabled>
                              <label for="survey_5_d" :class="survey_5 == 'D' ? 'now' : 'hide'"><span>6级-明显扩大毛孔，或内含突出毛孔的角栓，呈草莓样</span> <img src="../assets/images/pore_survey_4.png" alt=""></label>
                            
                            </li>

                          </ul>
                          <ul class="detail_options detail_options_5_1">
                            <li class="option_item">
                              <input type="radio" id="survey_5_1_a" value="A" disabled>
                              <label for="survey_5_1_a" :class="survey_6 == 'A' ? 'now' : 'hide'"><span>3级-清晰可见毛孔</span> <img src="../assets/images/pore_survey_1.png" alt=""></label>
                            
                            </li>
                            <li class="option_item">
                              <input type="radio" id="survey_5_1_b" value="B" disabled>
                              <label for="survey_5_1_b" :class="survey_6 == 'B' ? 'now' : 'hide'"><span>4级-明显可见毛孔，或内含小于毛孔大小的角栓</span> <img src="../assets/images/pore_survey_2.png" alt=""></label>
                            
                            </li>
                            <li class="option_item">
                              <input type="radio" id="survey_5_1_c" value="C" disabled>
                              <label for="survey_5_1_c" :class="survey_6 == 'C' ? 'now' : 'hide'"><span>5级-非常明显可见毛孔，或内含与毛孔大小一致的角栓</span> <img src="../assets/images/pore_survey_3.png" alt=""></label>
                            
                            </li>
                            <li class="option_item">
                              <input type="radio" id="survey_5_1_d" value="D" disabled>
                              <label for="survey_5_1_d" :class="survey_6 == 'D' ? 'now' : 'hide'"><span>6级-明显扩大毛孔，或内含突出毛孔的角栓，呈草莓样</span> <img src="../assets/images/pore_survey_4.png" alt=""></label>
                            
                            </li>

                          </ul>
                        </div>
                  
                    </div>
                    </div>
                  </div>
                </div>
              </transition>

             
		</div>

 
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";
var wx = require("weixin-js-sdk");
export default {
  name: "PoreGuideArea",
  data() {
    return {
      isload: false,
      in_weapp: false, //是否在小程序
      guide_area_data:null,
      show_rec:true,  //早晚护肤列表
      show_oth:false,  //对应类型产品
      guide_title_arr:[],  //毛孔护肤问题
        guide_detail_arr:[],  //毛孔对应详细数据
        show_guide_detail_layer:false,  //只展示详情弹窗 奴进行页面跳转
        show_rec:true,  //早晚护肤列表
        show_oth_pro:false,  //对应类型产品
        survey_3:null,  //问卷返回结果
        survey_5:null,
        survey_6:null,
        show_pore_level:false,  //毛孔等级弹窗
      imgs: [
        require("../assets/images/1.png"),
        require("../assets/images/2.png"),
        require("../assets/images/3.png"),
        require("../assets/images/4.png")
      ],
      demopic: require("../assets/images/10.png")
    };
  },

  created() {
    console.log("poreareaguide created", this);

    this.initGuideArea();
  },
  mounted() {
    var ua = navigator.userAgent.toLowerCase(),
      that = this;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          console.log("在小程序里");
          that.in_weapp = true;
        }
      });
    }
  },
  methods: {
    goMallDetail: function(pid) {
      if (this.in_weapp) {
        wx.miniProgram.navigateTo({
          url: "/mall-detail/mall-detail?scene=" + pid
        });
      } else {
        location.href =
          "https://www.uniskin.com.cn/homepage/m/pro_detail.html?p=" + pid;
      }
    },
    initGuideArea: function() {
      let that = this;
      var local_guide_area = JSON.parse(localStorage.getItem("local_guide_area"));
      if (local_guide_area) {
        afterGuideArea(local_guide_area);
      } else {
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/report199_ex1/getPoreSolution"
          )
          .then(json => {
            console.log('guidedata',json);
            afterGuideArea(json);
            // localStorage.setItem("local_guide_area",JSON.stringify(json));
          })
          .catch(err => {
            console.log(err);
            
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      }
      function afterGuideArea(guide_area_data) {
        if (guide_area_data.code == 0) {
          that.isload = true;
          that.guide_area_data = guide_area_data.data;
          if(guide_area_data.data.survey[3]){
            that.survey_3 = guide_area_data.data.survey[3];
          }
          if(guide_area_data.data.survey[5]){
            that.survey_5 = guide_area_data.data.survey[5];
          }
          if(guide_area_data.data.survey[6]){
            that.survey_6 = guide_area_data.data.survey[6];
          }


        }
      }
    },
    displayIng: function(ing) {
      this.show_ing = true;
      this.ing_obj = ing;
    },

    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";
//毛孔3-6级描述弹窗
.pore_level_toaster{
    position:fixed;
    width:100%;
    height:100%;
    top:0;
    left:0;
    background:rgba(0,0,0,0.3);
    .pore_level_toaster_inner{
      box-sizing:border-box;
      position:absolute;
      top:50%;
      left:50%;
      width:690/50rem;
      padding:50/50rem 30/50rem;
      background:@font-c-f;
      .border-radius(14/50rem);
      .shadow;
      -webkit-transform:translate(-50%,-50%);
      transform:translate(-50%,-50%);
    }
    .pore_level_toaster_inner_title{
      .display_flex;
      .flex-wrap_nowrap;
      .justify-content_flex-justify;
      span{
        font-size:34/50rem;
        line-height:1.1em;
        color:@font-c-detail;
        border-bottom:1px solid @font-c-detail;
      }
      img{
        width:30/50rem;
        height:30/50rem;
      }
    }
    .pore_level_toaster_inner_main{
      height:736/50rem;
      -webkit-overflow-y:scroll;
      overflow-y:scroll;
    }
  .survey_detail_3 .detail_options {
  padding-top: 10/50rem;
  .display_flex;
  .flex-wrap_wrap;
  .justify-content_flex-justify;
  .option_item {
    .display_flex;
    .flex-direction_column;
    .justify-content_flex-justify;
    box-sizing: border-box;
    height: 312/50rem;
    padding-top: 54/50rem;
    width: 47%;
    label {
      box-sizing: border-box;
      display: block;
      font-size: 24/50rem;
      line-height: 28/50rem;
      &::before {
        top: 0;
        transform: translateY(0);
      }
      .display_flex;
      .flex-direction_column;
      .flex-wrap_nowrap;
      .justify-content_flex-justify;
      height:100%;
      span{
        .flex_0;
      }
      img{
        .flex_0;
        box-sizing:border-box;
        margin: 10/50rem 0 0 0rem;
        width: 160/50rem;
      }
    }

  }
}
//第五题
.survey_5.survey_item {
  position: relative;
  .survey_detail {
    height: auto;
  }
}
.survey_detail_5 .detail_options {
  padding-top: 10/50rem;
  .display_flex;
  .flex-wrap_wrap;
  .justify-content_flex-justify;
  .option_item {
    .display_flex;
    .flex-direction_column;
    .justify-content_flex-justify;
    box-sizing: border-box;
    height: 312/50rem;
    padding-top: 54/50rem;
    width: 47%;
    label {
      box-sizing: border-box;
      display: block;
      font-size: 24/50rem;
      line-height: 28/50rem;
      &::before {
        top: 0;
        transform: translateY(0);
      }
      height:100%;
      .display_flex;
      .flex-direction_column;
      .flex-wrap_nowrap;
      .justify-content_flex-justify;
      span{
        .flex_0;
      }
      img{
        .flex_0;
        box-sizing: border-box;
        margin: 10/50rem 0 0 0rem;
        width: 160/50rem;
      }
    }

  }
}
.survey_detail_5 .detail_options_5 {
  padding-bottom: 53/50rem;
  padding-top: 50/50rem;
  .border-bottom-gray;
  &::before {
    content: "额头区域";
    display: block;
    position: absolute;
    top: 53/50rem;
    left: 0;
    font-size: 28/50rem;
    font-weight: bold;
    color: @font-c-3;
  }
}
.survey_detail_5 .detail_options_5_1 {
  padding-bottom: 53/50rem;
  padding-top: 40/50rem;
  .border-bottom-gray;
  &::before {
    content: "脸颊区域";
    display: block;
    position: absolute;
    top: 45/50rem;
    left: 0;
    font-size: 28/50rem;
    font-weight: bold;
    color: @font-c-3;
  }
}
.option_item input {
  position: absolute;
  top: 0;
  left: -100rem;
  opacity: 0;
}
.option_item label {
  position: relative;
  padding-left: 32/50rem;
  font-size: 34/50rem;
  line-height: 1em;
  color: @font-c-3;
  &::before {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 22/50rem;
    height: 22/50rem;
    .border-radius(50%);
    border: 1px solid @font-c-detail;
    background: transparent;
  }
}
.option_item label.hide::before {
  color: transparent;
  opacity:0;
}
.option_item label.now::before {
  border:1px solid #f05956;
  background: @font-c-detail;
}
.option_item label.now img {
  border:2px solid #f05956;
  .border-radius(14/50rem);
}
}

.guide_inner{
    background:@bg_c_m;
    padding:0 0 569/50rem;
}
.guide_inner_up{
    padding:106/50rem 30/50rem 0;
    background:@bg_c_m;
}
.back_btn{
    position:fixed;
    top:0.6rem;
    left:0;
    width:2.36rem;
    height:1.08rem;
    z-index:888;
}


.guide_title{
    padding-bottom:57/50rem;
    padding-left:96/50rem;
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-center;
    font-size:44/50rem;
    font-weight:bolder;
    line-height:1em;
    color:@font-c-3;
    .retest_ques{
        margin-left:10/50rem;
        font-size:24/50rem;
        line-height:1em;
        color:@font-c-detail;
        border-bottom:1px solid @font-c-detail;
        .align-self_flex-end;
    }
}
.yours_title{
    padding-bottom:22/50rem;
    font-size:34/50rem;
    line-height:1em;
    color:@font-c-3;
}
.yours_result_container{
    box-sizing:border-box;
    padding:13/50rem 0 34/50rem;
    .border-radius(14/50rem);
    background:#ffefef;
}
.yours_result{
    position:relative;
    padding:0 0 0 64/50rem;
    margin-top:21/50rem;
    font-size:28/50rem;
    line-height:1em;
    color:@font-c-detail;
    &::before{
        content:"";
        display:block;
        position:absolute;
        width:10px;
        height:10px;
        .border-radius(50%);
        background:@font-c-detail;
        left:44/50rem;
        top:50%;
        transform:translateY(-50%) scale(0.5);
    }
    strong{
        font-size:28/50rem;
        line-height:1em;
        color:@font-c-detail;
    }
    &.bordered{
        strong{
            border-bottom:1px solid @font-c-detail;
        }
    }
}
.yours_result_flex{
    .display_flex;
    .flex-wrap_wrap;
    .justify-content_flex-start;
    strong,img{
        .align-self_center;
    }
    img{
        width:30/50rem;
        height:30/50rem;
        margin-left:10/50rem;
    }
}
.main_point_title{
    padding-top:59/50rem;
    font-size:34/50rem;
    font-weight:bold;
    line-height:1em;
    color:@font-c-3;
}
.main_point_tip{
    padding:20/50rem 0 43/50rem;
    font-size:25/50rem;
    line-height:1em;
    color:@font-c-3;
}
.guide_area{
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    span{
        .flex_0;
        width:335/50rem;
        height:221/50rem;
        .border-radius(14/50rem);
        .shadow;
        line-height:221/50rem;
        color:@font-c-f;
        font-weight:bold;
        font-size:40/50rem;
        text-align:center;
        &:first-child{
            background:#b8c0da;
        }
        &:last-child{
            background:#a69fca;
        }
    }
}


</style>
